// IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
// Грид данных отчёта (AttrGrid):
//  1) раскрытая строка-группа (есть подчинённые, раскрыта) — режим doc.params.expanded_group_rows: hide — все ячейки значений приглушены вариантом
//     «Repeated group totals» (gt-dup-<вариант>, по умолчанию dim), круги видов ячеек в строке не создаются, наведение на строку показывает и то и другое;
//     repeats — прежнее правило (только повтор единственного потомка). Пусто — настройка базы fe.ux.parentRowHideExpanded (ВКЛ = hide);
//  2) итоговые колонки строки (итог периода `_total::<период>::<мера>`) — без заливки проблемных сигналов (signals_suppress), если не включено
//     doc.params.row_totals_signals; выключатель базы fe.ux.rowTotalsNoSignals (ВЫКЛ — как прежде). Итоговые строки (итоги по колонкам) не трогаются.

export const PARENT_HIDE_FLAG = 'fe.ux.parentRowHideExpanded'
export const ROW_TOTALS_FLAG = 'fe.ux.rowTotalsNoSignals'
export const PARENT_KEEP_COMPLEMENT_FLAG = 'fe.ux.parentSignalsKeepComplement'   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)

const rdOf = (read) => (typeof read === 'function' ? read : (k, d) => d)

// режим раскрытой строки-группы: 'hide' | 'repeats'
export function parentHide_mode(params, read) {
    const v = String(params?.expanded_group_rows ?? '').trim().toLowerCase()
    if (v === 'hide' || v === 'repeats') return v
    return rdOf(read)(PARENT_HIDE_FLAG, true) === false ? 'repeats' : 'hide'
}

// строка wijmo — раскрытая строка-группа данных отчёта (как у повтора итога группы: не tabrow, не строка сравнения)
// keepComplement (выключатель базы fe.ux.parentSignalsKeepComplement, ВКЛ): строка-группа, чьи видимые прямые потомки — только ДРУГИЕ меры (measure_)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)
// (дополнение к родителю: «Покриття запасу» под строкой запаса), а не расшифровка той же меры, — не «раскрытая группа»: её числа и круги остаются
export function parentHide_isRow(row, keepComplement = false) {
    if (!row || !row.hasChildren || row.isCollapsed || row.visible === false) return false
    const d = row.dataItem
    if (!(d && d._DLRow && d._DLRow.row_type !== 'tabrow' && !d._variant)) return false
    return !keepComplement || parentHide_childrenSameMeasure(row)   // IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)
}

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)
// мера строки данных отчёта: строка-мера раскладки (бэк кладёт measure_ = {id, binding, title, format}: «Покриття запасу» — binding offset,
// memo-строка) — её binding; строка без measure_ — мера колонки (значение отчёта), ключ ''
export function rowMeasure_of(dataItem) {
    const m = dataItem && typeof dataItem === 'object' ? dataItem.measure_ : undefined
    if (m === undefined || m === null || m === '') return ''
    if (typeof m === 'object') return String(m.binding ?? m.id ?? '')
    return String(m)
}

// IE 2026 11 03 / ODOO-350449 (заказ Игоря: p232 сигнал батьківського рядка лишається, якщо підлеглі — інша міра)
// раскрытая строка раскладывает СВОЮ меру: среди видимых прямых потомков (строки грида уровня + 1, без строк сравнения _variant) есть строка
// той же меры (rowMeasure_of). Все видимые прямые потомки — другие меры (дополнение) — false. Нет грида или видимых потомков — true
// (прежнее правило p201: раскрытая группа без чисел и кругов)
export function parentHide_childrenSameMeasure(row) {
    const rows = row?.grid?.rows, i0 = row?.index
    if (!rows || typeof i0 !== 'number' || i0 < 0) return true
    const pm = rowMeasure_of(row.dataItem), lvl = row.level ?? 0
    let seen = 0
    for (let j = i0 + 1; j < rows.length; j++) {
        const r = rows[j], l = r.level ?? 0
        if (l <= lvl) break
        if (l !== lvl + 1 || r.visible === false) continue
        const cd = r.dataItem
        if (!cd || cd._variant) continue
        seen++
        if (rowMeasure_of(cd) === pm) return true
    }
    return seen === 0
}

// колонка — итог строки за период (BE data_layout2: binding `_total::<период>::<мера>`)
export function rowTotal_is(binding) {
    return String(binding ?? '').startsWith('_total::')
}

// заливка сигналов в итогах строки: true — как прежде (опция отчёта или выключатель базы), false — снимать
export function rowTotals_signalsOn(params, read) {
    if (params?.row_totals_signals === true) return true
    return rdOf(read)(ROW_TOTALS_FLAG, true) === false
}
